export default "__VITE_ASSET__1a7886d0__"